import { TFunction } from '@uniqkey-frontend/shared-app';

interface IGenerateTooltipTitleParams {
  selectedDataLength: number;
  t: TFunction;
  isDisabled: boolean;
  key: string;
}

// eslint-disable-next-line import/prefer-default-export
export const generateTooltipTitle = (params: IGenerateTooltipTitleParams) => {
  const {
    selectedDataLength, t, isDisabled, key,
  } = params;
  if (!selectedDataLength) return t('common.tickRow');
  if (isDisabled) return t(`${key}.disabled`);
  return t(`${key}.active`);
};
